export default __webpack_public_path__ + "static/media/strikeandguard.e9c339ca.png";